export const selectContract = (state) => state.contract.contract;
export const selectContractLoading = (state) => state.contract.loading;
export const selectLoadingCase = (state) => state.contract.loadingCase;
export const selectLoadingPAU = (state) => state.contract.loadingPau;
export const selectContractError = (state) => state.contract.error

export const selectContractCase = (state) => state.contract.contract.case;
export const selectContractHistory = (state) => state.contract.contract.cases;

export const selectPreviousActiveCase = (state) => {
const previousActive =  state.contract.contract.cases?.find((e)=> e.showCurrent)
return previousActive
}

export const selectPAUEmail = (state) => state.contract.contract.contractData.email

export const selectContractList = (state)=> state.contract.contractList;
export const selectContractListLoading = (state)=> state.contract.loadingList;

export const selectHistoryCase = (state)=> state.contract.historyCase;